import React, { useMemo } from 'react';
import compact from 'lodash/compact';
import { Tooltip } from '@vectord/components';

import InstructorSelect from 'components/InstructorSelect';

function ScheduleInstructorSelect({ academyTopic, ...remainingProps }) {
  const _styles = {
    menu: (styles) => ({
      ...styles,
      minWidth: '24rem',
      width: 'max-content',
    }),
  };

  // Exclude already selected instructors
  const excludedInstructorIds = useMemo(() => {
    return compact(
      [
        academyTopic?.primaryInstructor,
        academyTopic?.secondaryInstructor,
        academyTopic?.otherInstructors,
      ].flat()
    ).map((i) => i.value);
  }, [
    academyTopic?.otherInstructors,
    academyTopic?.primaryInstructor,
    academyTopic?.secondaryInstructor,
  ]);

  return (
    <Tooltip
      isDisabled={academyTopic?.selected}
      title="Select class to be able to add instructor(s)"
    >
      <InstructorSelect
        {...remainingProps}
        compact
        isClearable
        isDisabled={!academyTopic?.selected}
        excludedInstructorIds={excludedInstructorIds}
        styles={_styles}
      />
    </Tooltip>
  );
}

export default ScheduleInstructorSelect;
